import { DOCS_URL } from "../../../config/constants.js";
import ServiceResultCard from "./ServiceResultCard.svelte";

export default {
    component: ServiceResultCard,
    name: "Service Result Card",
    description: "Compact result/stat card for service pages",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-serviceresultcard--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/chart-bar.svg",
    models: ["service-page"],
    hideFromInsertMenu: true,
    requiresParent: {
        message: "Service Result Card must be used inside a Service Callout Container.",
        component: "Service Callout Container",
    },
    inputs: [
        { friendlyName: "Label", name: "label", type: "string", defaultValue: "Results" },
        { friendlyName: "Result", name: "result", type: "string", required: true },
        { friendlyName: "Description", name: "description", type: "string", required: true },
        { friendlyName: "Meta 1", name: "metaOne", type: "string" },
        { friendlyName: "Meta 2", name: "metaTwo", type: "string" },
        { friendlyName: "Meta 3", name: "metaThree", type: "string" },
        {
            friendlyName: "Image",
            name: "image",
            type: "object",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "webp", "svg"],
                },
                { friendlyName: "Alt", name: "alt", type: "text", required: true },
            ],
        },
        { friendlyName: "Link", name: "link", type: "url" },
    ],
};
